import { useDraggable } from "@dnd-kit/core";
import { DragPayload } from "@/components/shared/DndProvider";

interface DraggableHistoryItemProps {
  itemId: string;
  dataId: string;
  children: React.ReactNode;
  globalEntries: { area: string; itemId: string; dataId?: string }[];
}

export function DraggableHistoryItem({
  itemId,
  dataId,
  children,
  globalEntries,
}: DraggableHistoryItemProps) {
  const selectedHistory = globalEntries.filter(e => e.area === 'history' && e.dataId);
  const isInSelection = selectedHistory.some(e => e.itemId === itemId);

  const payload: DragPayload = isInSelection && selectedHistory.length > 1
    ? {
        sourceArea: "history",
        itemIds: selectedHistory.map(e => e.itemId),
        dataIds: selectedHistory.map(e => e.dataId!),
      }
    : {
        sourceArea: "history",
        itemIds: [itemId],
        dataIds: [dataId],
      };

  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `history-${itemId}`,
    data: payload,
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{ opacity: isDragging ? 0.4 : 1 }}
    >
      {children}
    </div>
  );
}
